"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOutsideClick = void 0;

var react_1 = __importDefault(require("react"));
/**
 * Calls the passed callback whenever clicking outside the passed element.
 * @param container a ref to the container element
 * @param callback the callback to call whenever an outside click is done
 */


function useOutsideClick(container, callback) {
  react_1["default"].useEffect(function () {
    var handler = function handler(event) {
      if (container.current && !container.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener('mousedown', handler);
    return function () {
      document.removeEventListener('mousedown', handler);
    };
  }, [container]);
}

exports.useOutsideClick = useOutsideClick;